import { useParams } from 'react-router-dom';
import { config } from "../../data/config";
import { useEffect } from 'react';
import { getCookies } from "cookies-next";
import { useCookies } from 'react-cookie';
import axios from "axios";
import { useState } from "react";
import BreadCrump from "../tools/breadcrump"
import { EditCheckBox, EditItemText, EditItemTextArea, EditRadioBox, RadioBox } from './EditorForms';
import * as React from 'react';
import TissEditor from '../Editor/TissEditor';
import ImageUploader from '../tools/uploaderImage';
import { useTranslation } from 'react-i18next';
import { assert } from 'console';
import {Box, Checkbox, MenuItem, Modal, Select, TextField} from "@mui/material";
import HeaderOfPage from '../tools/headerOfPage';
interface DataObject {
    _id: string;
    typemode: string;
    parent: string;
    arranged: number;
    sized: number;
    data: { [key: string]: any }; // The data object can have any keys with any type of value
    createdAt: string;
    updatedAt: string;
    __v: number;
    id: string;

}
export default function EditForm() {
    const { t } = useTranslation();

    let cookie = getCookies();

    let { Id } = useParams();
    const [cookies, setCookie] = useCookies(['token', 'rule']);
    const [key, setKey] = useState<any>(1);
    const [error, setError] = useState<any>(null);
    const [listitem, setList] = useState<DataObject[]>([]);
    const [keys, setKeys] = useState<any>(1);

    const [item, UpdateItem] = useState<DataObject>();

    const [data, setData] = React.useState<any>(null);
    const save = async () => {

    }
    async function additem(typemode: String) {
        try {
            var path = `${config.url}/v1/dashboard/formDetail`;

            let res = await axios({
                method: 'post',
                url: path,
                data: {
                    parent: Id,
                    typemode: typemode

                },
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });
            loaditems();
        } catch (error) {

        }
    }
    const updateeditem = async () => {
        try {
            var path = `${config.url}/v1/dashboard/formDetail/${item?._id}`;

            let res = await axios({
                method: 'put',
                url: path,
                data: { data: item },
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });
            loaditems();
        } catch (error) {

        }
    }
    async function loaditems() {
        try {
            var path = `${config.url}/v1/dashboard/formDetail/${Id}`;

            let res = await axios({
                method: 'get',
                url: path,

                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });
            setList(res.data.message);

        } catch (error) {

        }

    }
    const load = async () => {
        try {
            var path = `${config.url}/v1/dashboard/formGroup/${Id}`;

            let res = await axios({
                method: 'get',
                url: path,
                headers: {
                    Authorization: 'Bearer ' + cookie['token'],
                }
            });
            setData(res.data.message)
        } catch (error) {

        }
    }
    const inputstyle = "py-3 px-5 block w-full border-gray-499 rounded text-sm focus:border-blue-500 focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none";
    const breadcrump = [
        {
            name: 'Dashboard',
            url: '/dashboard'
        },
        {
            name: 'Forms',
            url: '/dashboard/Blog'
        },
        {
            name: 'Form List',
            url: '/dashboard/Forms/formlist'
        },
        {
            name: 'Edit Form Group',
            url: null
        }
    ]
    const editItem = (item: any) => {
        UpdateItem((prevState): any => (item));
    }
    useEffect(() => {
        load();
        loaditems();
    }, []);
    return (
        <div>
            <BreadCrump data={breadcrump}></BreadCrump>
                <HeaderOfPage name="ویرایش فرم"></HeaderOfPage>

            {
                data != null && <div className='grid grid-cols-1 sm:grid-cols-5'>
                    <div >

                        <div className="p-3 bg-black rounded-[10px] text-right">
                          
                            <form key={key}>
                                <div className="max-w-sm space-y-3">
                                    <label className="text-white">{t('Name')} </label>
                                    <input
                                        defaultValue={data.name}
                                        type="text"
                                        className={`${inputstyle}     ${error != null && error['name'] != undefined && `bg-red-100`} `}
                                        placeholder="Name"
                                        onChange={(e) => setData({ ...data, name: e.target.value })}
                                    />
                                    {error != null && error['url'] != undefined && <small>{error['name']['message']}</small>}
                                </div>
                                <div className="max-w-sm space-y-3 mt-4">
                                    <label className="text-white"> Slug </label>
                                    <input
                                        type="text"
                                        defaultValue={data.url}
                                        className={`${inputstyle}       ${error != null && error['url'] != undefined && `bg-red-100`}  `}
                                        placeholder="Slug"
                                        onChange={(e) => setData({ ...data, url: e.target.value })}
                                    />
                                    {error != null && error['url'] != undefined && <small>{error['url']['message']}</small>}
                                </div>
                                <div className="max-w-sm space-y-3 mt-4">
                                    <label className="text-white">{t('Keywords')}  </label>
                                    <textarea
                                        defaultValue={data.keywords}
                                        className={inputstyle}
                                        onChange={(e) => setData({ ...data, keywords: e.target.value })}
                                        placeholder="..." />
                                </div>
                                <div className="max-w-sm space-y-3 mt-4">
                                    <label className="text-white">{t('Description')}   </label>
                                    <textarea

                                        defaultValue={data.description}

                                        className={inputstyle}
                                        onChange={(e) => setData({ ...data, description: e.target.value })}
                                        placeholder="..." />
                                </div>
                                <div className="max-w-sm space-y-3 mt-4">
                                    <button type="button"
                                            onClick={(e) => { save() }}
                                            className="py-3 px-4 inline-flex items-center gap-x-2 text-sm font-medium rounded-lg border border-transparent bg-gray-100 text-gray-800 hover:bg-gray-200 focus:outline-none focus:bg-gray-200 disabled:opacity-50 disabled:pointer-events-none dark:bg-white/10 dark:text-white dark:hover:bg-white/20 dark:hover:text-white dark:focus:bg-white/20 dark:focus:text-white"
                                    >{t('Update Category')}

                                    </button>

                                </div>
                            </form>

                            <div className='mt-3'>

                                <div className="text-white text-right">{t('Thumpnail')}  </div>
                                <ImageUploader id={data.id} component={'FormGroup'}></ImageUploader>
                            </div>


                        </div>
                    </div>

                    <div className='col-span-1 sm:col-span-4'>
                        <div className="grid sm:grid-cols-12 ">

                            <div className="col-span-12 gap-4 p-4 ">
                                <div className='grid grid-cols-12'>
                                    <div className='col-span-2 p-2'>
                                        <ul>
                                            <li className='cursor-pointer ' >
                                                <a onClick={(e) => { additem('textinput') }} >
                                                    <ButtonEditor src="/formeditor/input.svg " label={'ورودی متن'}></ButtonEditor>
                                                </a>
                                            </li>
                                            <li className=' cursor-pointer '>
                                                <a onClick={(e) => { additem('checkbox') }} >
                                                    <ButtonEditor src="/formeditor/checkbox.svg " label={'چک باکس'}></ButtonEditor>
                                                </a>
                                            </li>
                                            <li className=' cursor-pointer '>
                                                <a onClick={(e) => { additem('radio') }} >
                                                    <ButtonEditor src="/formeditor/radio.svg " label={'رادیو'}></ButtonEditor>
                                                </a>
                                            </li>
                                            <li className=' cursor-pointer '>
                                                <a onClick={(e) => { additem('textarea') }} >
                                                    <ButtonEditor src="/formeditor/textarea.svg " label={'نوشته'}></ButtonEditor>
                                                </a>
                                            </li>
                                            <li className=' cursor-pointer '>
                                                <a onClick={(e) => { additem('uploader') }} >
                                                    <ButtonEditor src="/formeditor/upload.svg " label={'آپلود'}></ButtonEditor>
                                                </a>
                                            </li>
                                            <li className=' cursor-pointer '>
                                                <a onClick={(e) => { additem('title') }} >
                                                    <ButtonEditor src="/formeditor/text.svg " label={'تیتر'}></ButtonEditor>
                                                </a>
                                            </li>

                                            <li className=' cursor-pointer '>
                                                <a onClick={(e) => { additem('selectbar') }} >
                                                    <ButtonEditor src="/formeditor/select.svg " label={'سلکت بار'}></ButtonEditor>
                                                </a>
                                            </li>
                                            <li className=' cursor-pointer '>
                                                <a onClick={(e) => { additem('text') }} >
                                                    <ButtonEditor src="/formeditor/text2.svg " label={'متن'}></ButtonEditor>
                                                </a>
                                            </li>

                                            <li className=' cursor-pointer '>
                                                <a onClick={(e) => { additem('image') }} >
                                                    <ButtonEditor src="/formeditor/image.svg " label={'عکس'}></ButtonEditor>
                                                </a>
                                            </li>
                                        </ul>

                                    </div>
                                    <div className='col-span-10  bg-slate-100 p-4'>
                                        <div className='text-left'>
                                            <button onClick={(e) => { load() }} className={`btn `}>دوباره خوانی</button>
                                        </div>
                                        <div className='grid grid-cols-2'>
                                            {
                                                listitem != undefined && listitem.map((item: any) => {
                                                    return (
                                                        <div className=' col-span-2' >
                                                            <div className={` w-full border-b-[1px] bg-slate-300 p-1 border-gray-400`}>
                                                                <div className='grid grid-cols-6'>
                                                                    <div className='text-right col-span-5'>
                                                                        {t(item.typemode)}
                                                                    </div>
                                                                    <div className=' text-left '>
                                                                        <div className=' gap-4 flex '>
                                                                            <div className='cursor-pointer' onClick={(e) => { editItem(item) }}>
                                                                                <button type="button" className="" aria-haspopup="dialog" aria-expanded="false" aria-controls="hs-scale-animation-modal" data-hs-overlay="#hs-scale-animation-modal">
                                                                                    <img src='/formeditor/edits.svg' width={20}></img>
                                                                                </button>

                                                                            </div>
                                                                            <div className='cursor-pointer' >
                                                                                <img src='/formeditor/top.svg' width={20}></img>
                                                                            </div>
                                                                            <div className='cursor-pointer' >
                                                                                <img src='/formeditor/down.svg' width={20}></img>
                                                                            </div>
                                                                            <div className='cursor-pointer'>
                                                                                <img src='/formeditor/full.svg' width={25}></img>
                                                                            </div>
                                                                            <div className='cursor-pointer pt-1'>
                                                                                <img src='/formeditor/trash.svg' width={20}></img>
                                                                            </div>

                                                                        </div>
                                                                    </div>
                                                                </div>

                                                            </div>
                                                            {item.typemode}
                                                            {item.typemode == "textinput" && <TextInput item={item}></TextInput>}
                                                            {item.typemode == "checkbox" && <CheckBox item={item}></CheckBox>}
                                                            {item.typemode == "radio" && <RadioBox item={item}></RadioBox>}
                                                            {item.typemode == "textarea" && <TextAreaInput item={item}></TextAreaInput>}
                                                            {item.typemode == "selectbar" && <SelectBar item={item}></SelectBar>}


                                                        </div>
                                                    )
                                                })
                                            }
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>

                        <div id="hs-scale-animation-modal"
                             className="hs-overlay hidden size-full fixed top-0 start-0 z-[80] overflow-x-hidden overflow-y-auto pointer-events-none" role="dialog"
                             tabIndex={-1}
                             aria-labelledby="hs-scale-animation-modal-label">
                            <div className="hs-overlay-animation-target hs-overlay-open:scale-100 hs-overlay-open:opacity-100 scale-95 opacity-0 ease-in-out transition-all duration-200 sm:max-w-lg sm:w-full m-3 sm:mx-auto min-h-[calc(100%-3.5rem)] flex items-center">
                                <div className="w-full flex flex-col bg-white border shadow-sm rounded-xl pointer-events-auto">

                                    {item == undefined ? <></> :
                                        item.typemode == "textinput" && <EditItemText UpdateItem={UpdateItem} item={item} ></EditItemText>

                                    }
                                    {item == undefined ? <></> :
                                        item.typemode == "checkbox" && <EditCheckBox UpdateItem={UpdateItem} item={item} ></EditCheckBox>

                                    }
                                    {item == undefined ? <></> :
                                        item.typemode == "radio" && <EditRadioBox UpdateItem={UpdateItem} item={item} ></EditRadioBox>

                                    }
                                    {item == undefined ? <></> :
                                        item.typemode == "textarea" && <EditItemTextArea UpdateItem={UpdateItem} item={item} ></EditItemTextArea>

                                    }
                                    {item == undefined ? <></> :
                                        item.typemode == "selectbar" && <EditCheckBox UpdateItem={UpdateItem} item={item} ></EditCheckBox>

                                    }
                                    {item == undefined ? <></> :
                                        item.typemode == "text" && <EditCheckBox UpdateItem={UpdateItem} item={item} ></EditCheckBox>

                                    }
                                    {item == undefined ? <></> :
                                        item.typemode == "radio" && <EditCheckBox UpdateItem={UpdateItem} item={item} ></EditCheckBox>

                                    }



                                    <div className="flex justify-end items-center gap-x-2 py-3 px-4 border-t">
                                        <button type="button" className="py-2 px-3 inline-flex items-center gap-x-2 text-sm font-medium rounded-lg border border-gray-200 bg-white text-gray-800 shadow-sm hover:bg-gray-50 focus:outline-none focus:bg-gray-50 disabled:opacity-50 disabled:pointer-events-none" data-hs-overlay="#hs-scale-animation-modal">
                                            بستن
                                        </button>
                                        <button onClick={(e) => { updateeditem() }} type="button" className="py-2 px-3 inline-flex items-center gap-x-2 text-sm font-medium rounded-lg border border-transparent bg-blue-600 text-white hover:bg-blue-700 focus:outline-none focus:bg-blue-700 disabled:opacity-50 disabled:pointer-events-none">
                                            تغییر
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <TissEditor component='FormDescription' parent={data.id} />
                    </div>
                </div>
            }

        </div>
    )
}


const TextInput = ({ item }: any) => {
    return (
        <div className="">
            <div className='text-right pt-3 pb-3'>
                <label>{item?.data?.label} </label>
                <input type="text"
                       className="w-full py-3 px-4 block border-solid border-gray-500   rounded-lg text-sm focus:border-blue-500 focus:ring-blue-500 disabled:opacity-50 disabled:pointer-events-none dark:bg-neutral-900 dark:border-neutral-700 dark:text-neutral-400 dark:placeholder-neutral-500 dark:focus:ring-neutral-600"
                       placeholder={item?.data?.placeholder} />

            </div>
        </div>
    )
}
const SelectBar = ({ item }: any) => {
    return (
        <div className="">
            <div className='text-right pt-3 pb-3'>
                <label>{item?.data?.label} </label>

                <div>
                  <Select fullWidth sx={{padding:'5px'}} >
                        {
                            item?.data?.options != null &&
                            item?.data?.options?.split("-").map((i: string, index: number) => {
                                return (
                                    <MenuItem>{i}</MenuItem>
                                );
                            })
                        }
                    </Select>
                </div>
            </div>
        </div>
    )
}
const TextAreaInput = ({item}: any) => {
    return (
        <div className="">
            <div className='text-right pt-3 pb-3'>
                <label>{item?.data?.label} </label>

               <TextField fullWidth rows={10} >

               </TextField>


            </div>
        </div>
    )
}
const CheckBox = ({item}: any) => {
    return (
        <div className="pb-4">
            <div className='text-right text-[15px]'>{item?.data?.description}</div>
            <div className='text-right pt-3 pb-3 flex gap-3'>
                <label className='text-right text-[15px]'>{item?.data?.label}  </label>
            </div>
            <div>
                {
                    item?.data?.options != null && <Box>
                        <div className={`grid grid-cols-4`}>
                            {item?.data?.options?.split("-").map((i: string, index: number) => {
                                return (
                                    <div key={index} className={`flex gap-2`}>
                                        <div className={`pt-1`}>
                                          <input className={'p-1'} type={'checkbox'} />
                                        </div>
                                        <div className={`pt-1`} >  { i }</div>
                                    </div>
                                );
                            })}
                        </div>

                    </Box>

                }
            </div>
        </div>
    )
}

export const ButtonEditor = ({ label, src }: any) => {
    return (
        <div className='text-left bg-slate-100 mt-3  rounded-[10px] p-1 border-b-[1px] border-gray-700'>
            <div className='grid grid-cols-6'>
                <div className='col-span-1'>
                    <img src={src} style={{ width: '20px' }}></img>
                </div>
                <div className='col-span-5 text-right pt-1 font-bold text-[13px]'>
                    {label}
                </div>
            </div>
        </div>
    )
}